import { useState, useEffect } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { getGrades } from "../../../ApiService/ApiService";
import GradesTable from "./GradesTable";
import AddGrade from "./AddGrade";
import { Add } from "@mui/icons-material";
function GradesSection() {
  const [grades, setGrades] = useState({});
  const [showAddGrade, setShowAddGrade] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchGrades();
  }, []);

  const fetchGrades = async () => {
    try {
      setLoading(true);
      const response = await getGrades();
      setGrades(response?.data);
    } catch (err) {
      console.error("Error fetching grades:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderMainContent = () => {
    if (showAddGrade) {
      return (
        <AddGrade fetchGrades={fetchGrades} setShowAddGrade={setShowAddGrade} />
      );
    } else {
      return <GradesTable grades={grades} fetchGrades={fetchGrades} />;
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showAddGrade ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          paragraph
          sx={{
            fontWeight: 600,
            fontSize: 22,
            fontFamily: "Barlow, sans-serif",
          }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Grades
        </Typography>
        <Button
          xs={8}
          sm={8}
          md={6}
          lg={4}
          xl={4}
          onClick={() => setShowAddGrade(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mb: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" />
          Add Grade
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderMainContent()}</>
      )}
    </>
  );
}

export default GradesSection;
